import dynamic from "next/dynamic";
import { gql, useQuery } from "utils/urql";

import { BreakingNewsQuery } from "types/api";

const BreakingNewsBarDisplay = dynamic(
  () => import("components/BreakingNewsBarDisplay")
);

const BREAKING_NEWS_QUERY = gql`
  query BreakingNews {
    breakingNews {
      id
      kicker
      text
      url
      theme
    }
  }
`;

const BreakingNewsBar = ({
  analyticsCategory,
}: {
  analyticsCategory?: string;
}) => {
  const [{ data }] = useQuery<BreakingNewsQuery>({
    query: BREAKING_NEWS_QUERY,
  });

  if (data?.breakingNews) {
    return (
      <BreakingNewsBarDisplay
        analyticsCategory={analyticsCategory}
        breakingNews={data.breakingNews}
      />
    );
  }

  return null;
};

export default BreakingNewsBar;
